import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface IMenuItem {
  type: string; // Possible values: link/dropDown/icon/separator/extLink
  name?: string; // Used as display text for item and title for separator type
  state?: string; // Router state
  icon?: string; // Material icon name
  tooltip?: string; // Tooltip text
  disabled?: boolean; // If true, item will not be appeared in sidenav.
  sub?: IChildItem[]; // Dropdown items
  badges?: IBadge[];
  info?: string;
}
interface IChildItem {
  type?: string;
  name: string; // Display text
  state?: string; // Router state
  icon?: string;
  sub?: IChildItem[];
  info?: string;
}

interface IBadge {
  color: string; // primary/accent/warn/hex color codes(#fff000)
  value: string; // Display text
}

@Injectable()
export class NavigationService {
  constructor() {}

  iconMenu: IMenuItem[] = [
    {
      name: 'Dashboard',
      type: 'link',
      tooltip: 'Dashboard',
      icon: 'dashboard',
      state: '',
    },
    {
      name: 'Leads',
      type: 'link',
      tooltip: 'Leads',
      icon: 'person',
      state: 'contacts',
      info:
        'Add a new lead or search through your existing leads of customers seeking to purchase properties',
    },
    {
      name: 'Properties',
      type: 'link',
      tooltip: 'Property',
      icon: 'business',
      state: 'properties',
      info:
        'List and view your properties. You control sharing these properties on Mashvisor or keeping them private',
    },
    {
      name: 'Property Marketplace',
      type: 'link',
      tooltip: 'Property Marketplace',
      icon: 'business',
      state: 'property-marketplace',
      info: "Search through Mashvisor's property marketplace",
    },
    {
      name: 'Settings',
      type: 'dropDown',
      tooltip: 'Calendar',
      icon: 'settings',
      sub: [
        {
          type: 'link',
          name: 'Import contacts',
          state: 'import-contacts',
          info:
            'Use this tool to easily import multiple leads from a CSV or Excel file',
        },
      ],
    },
  ];

  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle: string = 'Frequently Accessed';
  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.iconMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {
    this.menuItems.next(this.iconMenu);
  }
}
